var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-js',{ref:"player",staticClass:"player",class:[_vm.className],attrs:{"data-embed":"default"}})
}
var staticRenderFns = []

export { render, staticRenderFns }